import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            users: {
                data: [],
            },
            activeTab: 'active'
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        }
    },
    mutations: {
        setUsers(state, value) {
            state.users = value;
        },
        addUser(state, value) {
            state.users.data.unshift(value);
        },
        removeUser(state, item) {
            for (let i = 0; i < state.users.data.length; i++) {
                if (state.users.data[i].id === item.id) {
                    window.Vue.delete(state.users.data, i, item);
                }
            }
        },
        updateUser(state, item) {
            for (let i = 0; i < state.users.data.length; i++) {
                if (state.users.data[i].id === item.id) {
                    window.Vue.set(state.users.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/user', payload)
                    .then((response) => {
                        commit('setUsers', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allUser({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/user/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getUser({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/user/'+ id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createUser({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/user', form)
                    .then((response) => {
                        if (state.activeTab === 'not-visited' || window.laravel.isMaster) {
                            commit('addUser', response.data);
                        }
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        editUser({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.update('/user/'+ form.id, form)
                    .then((response) => {
                        commit('updateUser', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deleteItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/user/'+ id)
                    .then((response) => {
                        commit('removeUser',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        restoreItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/user/'+ id + '/restore')
                    .then((response) => {
                        commit('removeUser', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        resetPassword({state}, id) {
            return new Promise((resolve, reject) => {
                ApiService.post('/user/'+ id + '/reset-password')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        disableShortPageLimit({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.post('/user/'+ id + '/disable-short-page-limit')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};


